// extracted by mini-css-extract-plugin
export default {"adminPageSection":"adminPage_adminPageSection__r4E3S","usersListWrapper":"adminPage_usersListWrapper__ATaQg"};